/* Billing line-icon set + card-brand marks, ported from the billing design.
   Check/Back/Lock/Mail live in src/SVGS — same glyphs, reused here. */

import Check from "../../../../SVGS/Check";
import BackArrow from "../../../../SVGS/BackArrow";
import Lock from "../../../../SVGS/Lock";
import Mail from "../../../../SVGS/Mail";

export const I = {
  Check,
  Back: BackArrow,
  Lock,
  Mail,
  Dash: p => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...p}>
      <path d="M2.5 6h7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  Plus: p => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" {...p}>
      <path d="M7 2.5v9M2.5 7h9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  Close: p => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" {...p}>
      <path d="M2 2l10 10M12 2L2 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  Info: p => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...p}>
      <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.2" />
      <path d="M6 5.5v3M6 3.8v.4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  ),
  Alert: p => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 2.2l6.2 10.8H1.8L8 2.2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M8 6.5v3.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11.6" r=".9" fill="currentColor" />
    </svg>
  ),
  Gift: p => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <rect x="2.5" y="6.5" width="11" height="7.5" rx="1" stroke="currentColor" strokeWidth="1.3" />
      <path d="M2 6.5h12v2H2zM8 6.5V14M8 6.5S7 3.5 5.3 3.5A1.4 1.4 0 0 0 5 6.5M8 6.5S9 3.5 10.7 3.5A1.4 1.4 0 0 1 11 6.5" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    </svg>
  ),
  Clock: p => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" />
      <path d="M8 4.8V8l2.2 1.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  MapPin: p => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 14.5s5-4.2 5-8A5 5 0 0 0 3 6.5c0 3.8 5 8 5 8z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <circle cx="8" cy="6.5" r="1.8" stroke="currentColor" strokeWidth="1.3" />
    </svg>
  ),
  Sparkle: p => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 1.5l1.4 4.1 4.1 1.4-4.1 1.4L8 12.5 6.6 8.4 2.5 7l4.1-1.4L8 1.5z" fill="currentColor" />
    </svg>
  ),
  External: p => (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" {...p}>
      <path d="M5.5 3H3.2c-.7 0-1.2.5-1.2 1.2v6.6c0 .7.5 1.2 1.2 1.2h6.6c.7 0 1.2-.5 1.2-1.2V8.5M8 2h4v4M12 2L6.5 7.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ArrowRight: p => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" {...p}>
      <path d="M2.5 7h9M8 3.5L11.5 7 8 10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Card: p => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <rect x="1.8" y="3.5" width="12.4" height="9" rx="1.6" stroke="currentColor" strokeWidth="1.4" />
      <path d="M1.8 6.5h12.4M4 10h2.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  Building: p => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M2.5 14V3.2c0-.4.3-.7.7-.7h6.1c.4 0 .7.3.7.7V14M10 14V6.5h2.8c.4 0 .7.3.7.7V14M2 14h12M4.6 5.3h1M7 5.3h1M4.6 7.8h1M7 7.8h1M4.6 10.3h1M7 10.3h1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Upload: p => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 10.6V3.2M5.2 5.8L8 3l2.8 2.8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.6 10.2v2.1c0 .7.5 1.2 1.2 1.2h8.4c.7 0 1.2-.5 1.2-1.2v-2.1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  Doc: p => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M4 1.9h4.3L12 5.7V13c0 .7-.5 1.2-1.2 1.2H4c-.7 0-1.2-.5-1.2-1.2V3.1c0-.7.5-1.2 1.2-1.2z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <path d="M8 2v3.6h3.6M5.6 8.6h4.8M5.6 10.9h3.4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
};

/* Simplified, generic card-brand marks (not official logos). */
const BRAND = {
  visa: () => (
    <svg width="34" height="22" viewBox="0 0 34 22">
      <rect width="34" height="22" rx="3" fill="#fff" stroke="#E3E3E3" />
      <text x="17" y="15.5" textAnchor="middle" fontFamily="Inter,sans-serif" fontWeight="700" fontStyle="italic" fontSize="9" letterSpacing=".3" fill="#1A1F71">VISA</text>
    </svg>
  ),
  mastercard: () => (
    <svg width="34" height="22" viewBox="0 0 34 22">
      <rect width="34" height="22" rx="3" fill="#fff" stroke="#E3E3E3" />
      <circle cx="14.5" cy="11" r="5.4" fill="#EB001B" />
      <circle cx="20.5" cy="11" r="5.4" fill="#F79E1B" fillOpacity=".85" />
    </svg>
  ),
  amex: () => (
    <svg width="34" height="22" viewBox="0 0 34 22">
      <rect width="34" height="22" rx="3" fill="#1F72CD" />
      <text x="17" y="14.5" textAnchor="middle" fontFamily="Inter,sans-serif" fontWeight="700" fontSize="6.5" letterSpacing=".2" fill="#fff">AMEX</text>
    </svg>
  ),
  generic: () => (
    <svg width="34" height="22" viewBox="0 0 34 22">
      <rect width="34" height="22" rx="3" fill="#fff" stroke="#E3E3E3" />
      <rect x="5" y="7" width="24" height="2.4" rx="1.2" fill="#C7C7C7" />
      <rect x="5" y="12" width="12" height="2.4" rx="1.2" fill="#E3E3E3" />
    </svg>
  )
};

export const CardBrand = ({ brand }) => {
  const Mark = BRAND[brand] || BRAND.generic;
  return <Mark />;
};

const BRAND_NAMES = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
  discover: "Discover",
  diners: "Diners",
  jcb: "JCB",
  unionpay: "UnionPay"
};

export const brandName = brand => BRAND_NAMES[brand] || "Card";

export const cardLabel = pm =>
  pm ? `${brandName(pm.brand)} •••• ${pm.last4}` : null;
